import * as React from 'react';
import ShowOutlined from './show-outlined';
import ShowFilled from './show-filled';
import type { IconCombinedProps } from './types';
const ShowCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ShowFilled ref={ref} {...rest} />;
  }
  return <ShowOutlined ref={ref} {...rest} />;
});
export default ShowCombined;